import { fun_PostAction, fun_Download } from "@/api/index";
import { fun_DownloadFile } from "@/utils/validate.js";
import { Loading } from "element-ui";
import PrintDialog from "../../components/PrintDialog/index.vue";
import OpenBidRecord from "../components/openBidRecord/index.vue";
import { fun_GetKeys } from "../../../../utils/validate";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 判断是否从工作台进入
      workbenchMenu: null,
      // 工作台状态
      workbenchState: true,
      // 全局加载
      fullLoading: null,
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
        regulators: null, // 招标监管部门
        isPayment: null, // 是否缴纳服务费
        publicityStartDate: null, // 公示开始日期
        publicityEndDate: null // 公示结束日期
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入"
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
        {
          type: "date",
          label: "公示开始日期：",
          dateType: "date",
          value: "publicityStartDate",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd"
        },
        {
          type: "date",
          label: "公示结束日期：",
          dateType: "date",
          value: "publicityEndDate",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd"
        }
      ],
      // 表格按钮
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          width: "380",
          isShow: true,
          fixed: true
        },
        {
          label: "状态",
          slotName: "state",
          width: "120"
        },
        {
          label: "中标公示表",
          slotName: "print",
          width: "120"
        },
        {
          label: "开标记录",
          slotName: "openingRecord",
          width: "130"
        },
        {
          label: "公平竞争审查表",
          slotName: "check",
          width: "150"
        },
        {
          label: "招标组织形式",
          prop: "tenderMethodFlag",
          width: "130"
        },
        {
          label: "公示状态",
          slotName: "publicState",
          width: "100"
        },
        {
          label: "发布状态",
          slotName: "isReleaseState",
          width: "100"
        },
        {
          label: "所属缴费交易中心",
          prop: "tradingCenterName",
          width: "250"
        },
        {
          label: "是否缴费",
          slotName: "isPayment",
          width: "110"
        },
        {
          label: "中标价（万元）",
          slotName: "winningPrice",
          width: "150"
        },
        {
          label: "标段号",
          prop: "section"
        },
        {
          label: "中标公示开始日期",
          prop: "publicityStartDate",
          width: "180"
        },
        {
          label: "中标公示结束日期",
          prop: "publicityEndDate",
          width: "180"
        },
        {
          label: "招标投标监管部门",
          prop: "regulators",
          width: "300"
        }
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 温馨提示
      tipList: [
        /* {
           type: "text",
           text: "（1）中标候选人由招标人/招标代理机构录入到本平台。",
         },
         {
           type: "text",
           text: "（2）中标候选人须提交后，中标候选人将向全社会公示。",
         },
         {
           type: "text",
           text: "（3）新增：点击“添加”；修改：勾选对应项目，点击“修改”；删除：勾选对应项目，点击“删除”。",
         },
         {
           type: "text",
           text: "（4）当状态为\"招标人确认中\"时，招标人请点击项目名称进入详情后进行操作。",
         },
         {
           type: "AdobeReader",
         },*/
      ],
      // 默认隐藏开标记录弹窗
      dialogVisible: false,
      // 勾选的数组
      multipleSelection: [],
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      // 默认隐藏公平竞争审查表弹窗
      pdfDialogVisible: false,
      // pdf路径
      pdfUrl: null
    };
  },
  // 注册组件
  components: {
    PrintDialog,
    OpenBidRecord
  },
  // 模板编译前
  created() {
    // 获取数据
    this.workbenchMenu = sessionStorage.getItem("workbenchMenu")
      ? sessionStorage.getItem("workbenchMenu")
      : null;
  },
  // 模板编译完成
  mounted() {
    // 如果用户标识是工作人员或者监管人员
    if (
      this.userFlag === "工作人员" ||
      this.userFlag === "监管人员" ||
      this.userFlag === "分包合同监管人员"
    ) {
      // 工作人员
      if (this.userFlag === "工作人员") {
        // 报表导出
        this.btnList = [
          {
            type: "slot",
            slotName: "export"
          }
        ];
      } else {
        // 清空表头
        this.btnList = [];
      }
    }
    // 默认打开项目评审列表
    this.fun_GetList();
    // 获取工作台状态
    this.fun_GetWorkbenchState();
  },

  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction(
          "/winningPublicity/list",
          {
            ...this.form,
            ...this.reqPageData
          },
          0
        );
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 获取工作台状态
     */
    fun_GetWorkbenchState() {
      // 请求，获取结果集
      fun_PostAction("/winningPublicity/getWorkbenchState", {}).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 回显table
          this.workbenchState = data.workbenchState;
        }
      });
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 跳转详情页面
          this.$router.push({
            path: "/winningPublicityDetail",
            // 操作类型
            query: { type: "insert" }
          });
          break;
        case "修改":
          // 执行修改的方法
          this.fun_Edit();
          break;
        case "删除":
          // 执行删除的方法
          this.fun_Del();
          break;
        case "文档输出":
          // 执行导出的方法
          this.fun_ImportTxt();
          break;
      }
    },

    /**
     * 修改的方法
     * @author shuhua
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 甲方确认信息编号
          var tenderSignedId = this.multipleSelection[0].tenderSignedId;
          // 甲方确认状态
          var tenderSignedState = this.multipleSelection[0].tenderSignedState;
          // 是否为甲方
          var tenderCorpFlag = this.multipleSelection[0].tenderCorpFlag;
          // 招标组织形式
          var tenderMethod = this.multipleSelection[0].tenderMethod;
          // 状态
          var state = this.multipleSelection[0].state;
          // 实际中标人编号
          var basicInfoId = this.multipleSelection[0].basicInfoId;
          // 状态名称
          var stateName = "";
          // 检查状态
          var checkFlg = true;
          // 判断状态
          if (state === "tj") {
            // 状态名称
            stateName = "提交";
            // 存在甲方确认信息的场合
            if (tenderSignedId != "" && tenderSignedId != null) {
              // 甲方确认状态等于提交的场合
              if (tenderSignedState == "tj") {
                stateName = "招标人确认中";
                checkFlg = false;
                // 甲方确认状态等于通过的场合
              } else if (tenderSignedState == "tg") {
                stateName = "提交";
                checkFlg = false;
                // 甲方确认状态等于保存的场合
              } else if (tenderSignedState == "bc") {
                stateName = "提交";
                checkFlg = false;
              }
            } else {
              checkFlg = false;
            }
          }
          // 如果招标组织形式不为空，且不是自行组织
          if (tenderMethod && tenderMethod !== "1") {
            // 则验证若是招标人则不能修改操作
            if (tenderCorpFlag === "01") {
              // 提示
              this.$alert(
                "该项目为委托招标请直接点击项目进入详情进行操作，不能修改项目数据。",
                "warning"
              );
              return;
            }
          }
          // 实际中标候选人不为空
          if (basicInfoId != null && basicInfoId != "") {
            // 提示
            this.$alert("该项目中标通知书已发送，无法进行修改操作", "warning");
            return;
          }
          // 验证失败的场合
          if (!checkFlg) {
            // 提示
            this.$alert(
              "该项目当前状态为“" + stateName + "”，不能修改！",
              "warning"
            );
            return;
          }
          // 已发布，作废
          if (
            this.multipleSelection[0].isReleaseState === "1" &&
            this.multipleSelection[0].publicState === "1"
          ) {
            // 提示
            this.$alert("已作废的中标公示不能修改！", "warning");
            return;
          }
          // 跳转路由
          this.$router.push({
            path: "/winningPublicityDetail",
            query: {
              id: this.multipleSelection[0].id,
              type: "update"
            }
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请至少选中一行数据！", "warning");
        return;
      }
    },

    /**
     * 删除的方法
     * @author shuhua
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        }
        // 是否为甲方
        var tenderCorpFlag = this.multipleSelection[0].tenderCorpFlag;
        // 招标组织形式
        var tenderMethod = this.multipleSelection[0].tenderMethod;
        // 如果招标组织形式不是 自行组织
        if (tenderMethod && tenderMethod !== "1") {
          // 则验证若是招标人则不能修改操作
          if (tenderCorpFlag === "01") {
            // 提示
            this.$alert(
              "该项目为委托招标请联系招标代理做删除操作。",
              "warning"
            );
            return;
          }
        }
        // 存在已核验专家则删除
        if (
          this.multipleSelection[0].state === "tj" ||
          this.multipleSelection[0].state === "tg"
        ) {
          // 提示
          this.$alert(
            "选中数据存在已提交或通过的中标公示，不能删除！",
            "warning"
          );
          return;
        }
        // 弹出询问confirm
        this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 获取keys
          const keys = fun_GetKeys(this.multipleSelection);
          // 发起请求，获取结果集
          fun_PostAction("/winningPublicity/delete?key=" + keys).then(res => {
            // 解构res.data
            const { result, msg } = res.data;
            // 判断请求是否成功
            if (result) {
              // 查询列表
              this.fun_GetList();
              // 提示删除成功
              this.$message.success(msg);
            } else {
              // 请求失败，提示信息
              this.$message.error(msg);
            }
          });
        });
      } else {
        // 未勾选，则提示
        this.$alert("请至少选中一行数据！", "warning");
        return;
      }
    },

    /**
     * 文本文档输出
     * @author shuhua
     */
    fun_ImportTxt() {
      // 下载文件
      fun_Download("/winningPublicity/exportTxt", {
        ...this.form
      }).then(res => {
        // 打开遮罩
        this.fun_Loading();
        // 获取响应头中的content-disposition
        let fileNames = res.headers["content-disposition"];
        // 如果响应头中存在content-disposition
        if (fileNames) {
          // 获取文件名，匹配内容为文件名
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          // 调用下载文件公共方法
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
        // 加载框取消
        this.fullLoading.close();
      });
    },

    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },

    /**
     * 打印的方法
     * @author shuhua
     */
    fun_DialogForPrint(data) {
      // 打开弹窗
      this.$refs.printDialog.dialogVisible = true;
      // 主键
      this.$refs.printDialog.id = data.id;
      // 编号
      this.$refs.printDialog.everyIds = data.tenderReference;
      // ids
      this.$refs.printDialog.data = data.id;
      // 权限编号
      this.$refs.printDialog.operationNum = "201606061508000017";
    },

    /**
     * 打印的方法
     */
    fun_DialogPrint(
      id,
      agency,
      tender,
      agencyRecords,
      bidder,
      lock,
      recordNumber,
      flag
    ) {
      // 发起请求
      fun_Download("/dialogPrint", {
        controller: "winningPublicityPrint",
        id: id,
        agency: agency,
        tender: tender,
        agencyRecords: agencyRecords,
        lock: lock,
        recordNumber: recordNumber
      }).then(res => {
        const data = new Blob([res.data], { type: "application/pdf" });
        const reader = new FileReader();
        // 如果文件大小等于0
        if (data.size == 0) {
          this.$message.success("文件生成中！");
        } else {
          //
          this.$refs.printDialog.isShow = true;
          // 读取文件
          reader.readAsText(data);
          // 触发onload事件
          reader.onload = () => {
            // json格式数据转换成对象
            if (reader.result.indexOf("result") > -1) {
              const result = JSON.parse(reader.result);
              if (result.result == false) {
                this.$message.error(result.msg);
              }
            } else {
              this.$refs.printDialog.pdfUrl =
                "./static/pdf/web/viewer.html?file=" +
                encodeURIComponent(URL.createObjectURL(data));
            }
          };
        }
      });
    },
    /**
     * 查看招标登记详情
     * @author shuhua
     */
    fun_OpenRecord(e) {
      // 打开弹窗
      this.dialogVisible = true;
      // 执行详情的方法
      this.$nextTick(() => {
        // 主键
        this.$refs.openBidRecord.id = e;
        // 获取详情
        this.$refs.openBidRecord.fun_Details();
      });
    },

    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 判断开始时间是否大于结束时间
      if (
        new Date(this.form.publicityEndDate).getTime() <
        new Date(this.form.publicityStartDate).getTime()
      ) {
        // 提示
        this.$alert("结束时间需大于等于开始时间！", "warning");
        return;
      }
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 跳转参数
      let obj = {
        id: e.val.id,
        webFlag: "0",
        type: "detail"
      };
      // 招标人签章状态不为空
      if (e.val.tenderSignedState) {
        // 修改参数
        obj = {
          isTenderSignature: "1",
          id: e.val.id,
          webFlag: "0",
          type: "detail"
        };
      }
      // 跳转路由
      this.$router.push({
        path: "/winningPublicityDetail",
        query: obj
      });
    },

    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      // 全局加载
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
    },

    /**
     * 公平竞争审查表查看
     */
    fun_FairCompetitionReviewLook(data) {
      // 获取id
      fun_Download(
        "/winningPublicity/getFairCompetitionReview?id=" + data.tenderReference
      ).then(res => {
        if (res) {
          if (res.data.type === "application/json") {
            this.$message.error("文件不存在！");
            return;
          }
          // 存储this
          const data = new Blob([res.data], { type: "application/pdf" });
          this.pdfDialogVisible = true;
          this.pdfUrl =
            "./static/pdf/web/viewer.html?file=" +
            encodeURIComponent(URL.createObjectURL(data));
        }
      });
    }
  }
};
